import * as turf from "@turf/turf"
import booleanValid from "@turf/boolean-valid"
export function reverseCoordinates(inputString: string) {
  if (!inputString) {
    return
  }
  // Parse the input string into an array of coordinate pairs
  let coordinates = JSON.parse(inputString)

  // Iterate through each coordinate pair and reverse the order of elements
  for (let i = 0; i < coordinates.length; i++) {
    coordinates[i] = coordinates[i].reverse().map((val: number) => parseFloat(val.toFixed(5)))
  }

  // Convert the array back to a string
  let reversedString = JSON.stringify(coordinates)

  return reversedString
}

export function roundCoordinates(inputString: string) {
  if (!inputString) {
    return
  }
  // Parse the input string into a 2D array of coordinates
  let coordinates = JSON.parse(inputString)

  // Iterate over each coordinate pair and round the numbers to the specified decimal places
  let roundedCoordinates = coordinates.map((pair: any[]) =>
    pair.map((coord) => {
      return parseFloat(Number(coord).toFixed(3))
    })
  )

  // Convert the rounded coordinates back to a string
  let roundedString = JSON.stringify(roundedCoordinates)

  return roundedString
}

export function isValidJSON(formData: string) {
  if (!formData) {
    return
  }
  try {
    JSON.parse(formData)
    return true
  } catch (error) {
    return false
  }
}

export function isValidPolygon(formData: string) {
  if (!formData) {
    return
  }
  try {
    const coordinates = JSON.parse(formData)

    // Create a Turf.js Feature object with the coordinates
    const polygonFeature = turf.polygon([coordinates])
    const isValidPolygon = booleanValid(polygonFeature)
    return isValidPolygon
  } catch (error) {
    return false
  }
}

export function isValidCoordinateString(formData: string) {
  if (!formData) {
    return
  }
  try {
    const coordinates = JSON.parse(formData)
    if (!Array.isArray(coordinates)) return false
    for (const pair of coordinates) {
      if (!Array.isArray(pair) || pair.length !== 2) return false
      const [x, y] = pair
      if (typeof x !== "number" || typeof y !== "number" || isNaN(x) || isNaN(y)) return false
    }
    return true
  } catch (error) {
    return false
  }
}
